export const tablet = "(max-width: 1000px)";
export const tabletSmall = "(max-width: 699px)";
export const mobile = "(max-width: 480px)";
